import { render, staticRenderFns } from "./ClassSubjectNumberPrStudent.vue?vue&type=template&id=21020478&"
import script from "./ClassSubjectNumberPrStudent.vue?vue&type=script&lang=ts&"
export * from "./ClassSubjectNumberPrStudent.vue?vue&type=script&lang=ts&"
import style0 from "./ClassSubjectNumberPrStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports